import React from "react";
import { cn } from "@/lib/utils";

export function Eyebrow({ children, className }) {
    return <p className={cn("eyebrow", className)}>{children}</p>;
}

// Headline period. The subtly emphasized final period is the brand signature.
export function Dot() {
    return <span className="period">.</span>;
}
